import React from 'react';
import { useParams } from 'react-router-dom';
import TrackingPanel from '../components/TrackingPanel';
import { useLanguage } from '../i18n/LanguageContext';

function TrackingPage() {
  const { number = '' } = useParams();
  const { t } = useLanguage();

  return (
    <section className="page-section tracking-page">
      <div className="shell">
        <div className="page-heading">
          <p className="eyebrow">{t.trackingPage.eyebrow}</p>
          <h1>{t.trackingPage.title}</h1>
          <p>{t.trackingPage.lead}</p>
        </div>
        <TrackingPanel initialCode={number} />
      </div>
    </section>
  );
}

export default TrackingPage;
